import React, {Component} from 'react';
import * as messageConstants from '../../../shared/messages';
import {CopyToClipboard} from "react-copy-to-clipboard";
import "./ClientCredentials.scss"
import GenerateClientSecretModal from './GenerateClientSecretModal';

class ClientCredentials extends Component {
    state = {
        copiedClientId: false,
        copiedClientSecret: false,
        showGenerateSecretModal: false,
    }
    handleCopyTextClear = (event) => {
        const textItem = event.currentTarget.id;
        const copied = {};

        copied[textItem] = false;
        this.setState(copied);
    }

    handleCopyText = (event) => {
        const textItem = event.currentTarget.id;
        const copied = {};
        copied[textItem] = true;
        this.setState(copied);
    }

    handleGenerateNewClientSecretPopUp = () => {
        this.setState({
            showGenerateSecretModal: true,
        });
    }

    handleHideGenerateSecretModal = () => {
        this.setState({
            showGenerateSecretModal: false,
        });
    }

    handleConfirmGenerateSecret = () => {
        const appId = this.props.applicationId;
        if (appId) {
            this.props.generateOidcClientCredentials(appId);
        }
        this.setState({
            showGenerateSecretModal: false,
        });
    }

  render() {
    return (
        <div className="oidc-credentials-container">
            <p className="sba-subtitle">
              {messageConstants.OIDC_CLIENT_CREDENTIALS}
            </p>
            {this.props.clientId ? (
                <div>
                    <label
                        className="oidc-credentials-label-title">{messageConstants.OIDC_CLIENT_ID}</label>
                      <div className="copy-row">
                          <div className="oidc-credentials-entry-value"
                               id="clientIdValue">
                              {this.props.clientId}
                          </div>
                          <div className="copy-link">
                              <CopyToClipboard
                                  text={this.props.clientId}>
                                  {
                                      this.state.copiedClientId ? (
                                          <input id="copiedClientId"
                                                 onClick={this.handleCopyTextClear}
                                                 type="button"
                                                 value={messageConstants.COPIED}
                                                 className="button_check"/>
                                      ) : (
                                          <button
                                              title={messageConstants.COPY}
                                              id="copiedClientId"
                                              className="btn btn-link"
                                              onClick={this.handleCopyText}
                                          >
                                              <i className="copy-mark"/>
                                          </button>
                                      )
                                  }
                              </CopyToClipboard>
                      </div>
                  </div>
                  <div>
                      <div className="client-secret-row-generate">
                          <label className="oidc-credentials-label-title">{messageConstants.OIDC_CLIENT_SECRET}</label>
                      {this.props.applicationId ? (
                              <button type="button"
                                  className="attr-button"
                                  onClick={() => this.handleGenerateNewClientSecretPopUp()}
                              >
                                  <span className="attr-button-label">{messageConstants.OIDC_GENERATE_NEW_CLIENT_SECRET}
                                  </span>
                              </button>
                      ) : null}
                      </div>
                      {this.props.clientSecret ? (
                      <div className="copy-row">
                          <div className="oidc-credentials-entry-value"
                               id="clientSecretValue">
                              {this.props.clientSecret}
                          </div>
                          <div className="copy-link">
                              <CopyToClipboard
                                  text={this.props.clientSecret}>
                                  {
                                      this.state.copiedClientSecret ? (
                                          <input id="copiedClientSecret"
                                              onClick={this.handleCopyTextClear}
                                              type="button"
                                              value={messageConstants.COPIED}
                                              className="button_check"/>
                                      ) : (
                                          <button
                                              title={messageConstants.COPY}
                                              id="copiedClientSecret"
                                              className="btn btn-link"
                                              onClick={this.handleCopyText}
                                          >
                                              <i className="copy-mark"/>
                                          </button>
                                      )
                                  }
                              </CopyToClipboard>
                          </div>
                      </div>
                          ) : null }
                  </div>
                </div>
            ) : null }

              {!this.props.clientId ? (
                  <button
                      id="generateOidcCredentials"
                      type="button"
                      className={this.props.clientId
                          ? "btn btn-md oidc-generate-secret-button"
                          : "btn btn-md btn-primary oidc-generate-client-credentials"}
                      onClick={this.props.generateOidcClientCredentials}
                  >
                      {messageConstants.OIDC_GENERATE_CLIENT_CREDENTIALS}
                  </button>
              ) : null }
              <GenerateClientSecretModal
                show={this.state.showGenerateSecretModal}
                onHide={this.handleHideGenerateSecretModal}
                onConfirm={this.handleConfirmGenerateSecret}
              />
        </div>
    );
  }
}

export default ClientCredentials;
